module Meevo.Components.Controls.HideInput {
    export abstract class ConverterBase implements IStringConverter {
        preUpdateValue(str: string): string {
            return str;
        }

        modelValue(str: string): any {
            return str;
        }

        hide(str: string): string {
            if (str.length < 3) {
                return str;
            }

            return `${str[0]}${str.slice(1, -1).replace(/(.{1})/g, '*')}${str.slice(-1)}`;
        }

        abstract valid(str: string): boolean;

        parseModelValue(modelValue: any): string {
            return modelValue;
        }

        isEqual(value1: any, value2: any): boolean {
            return  value1 === value2;
        }
    }
}
